<template>
    <v-menu v-model="searchDateMenu" :close-on-content-click="false">
        <template v-slot:activator="{ props }">
            <div class="selected-date-container">
                <v-icon v-bind="props" color="var(--text-color)">mdi-calendar</v-icon>
                <span v-if="filterStartDate && filterEndDate">{{ filterStartDate + ' to ' + filterEndDate }}</span>
                <span v-else>Filter by Date</span>
                <v-icon v-bind="props" color="var(--text-color)" v-if="filterStartDate" @click="clearDate">mdi-close</v-icon>
            </div>
        </template>
        <v-date-picker v-model="searchDateValue" multiple="range" show-adjacent-months :max="new Date()" @input="afterDateSelected">
                <template #actions>
                    <v-btn @click="clearDate">Cancel</v-btn>
                    <v-btn @click="afterDateSelected">OK</v-btn>
                </template>
        </v-date-picker>
    </v-menu>
  </template>
  
  <script>
  export default {
    name: "DatePicker",
    props: {
      selectedDate: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        searchDateMenu: false,
        searchDateValue: this.selectedDate,
        filterStartDate: null,
        filterEnddate: null
      };
    },
    methods: {
      afterDateSelected() {
        if(this.searchDateValue.length > 1) {
            this.filterStartDate = new Date(this.searchDateValue[0]).toISOString().slice(0,10);
            this.filterEndDate = new Date(this.searchDateValue[this.searchDateValue.length - 1]).toISOString().slice(0,10);            this.searchDateMenu = false;
        } else {
            this.filterStartDate = new Date(this.searchDateValue[0]).toISOString().slice(0,10);
            this.filterEndDate = new Date(this.searchDateValue[0]).toISOString().slice(0,10);
        }
        this.$emit("update:selectedDate", this.searchDateValue);
      },
      clearDate() {
        this.searchDateValue = "";
        this.filterStartDate = null;
        this.filterEndDate = null;
        this.$emit("update:selectedDate", this.searchDateValue);
      }
    },
    watch: {
        searchDateMenu(val) {
            this.searchDateMenu = val;
        },
        searchDateValue() {
            this.afterDateSelected();
        }
    },
  };
  </script>
  
  <style scoped>
 

  .button-container {
    display: flex;
    justify-content: flex-end;
    padding: 0.5rem;
  }
  
  .reset-button {
    background-color: #f44336;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .reset-button:hover {
    background-color: #d32f2f;
  }

  .selected-date-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
    gap: 8px;
    padding: 12px 20px;
    border-radius: 32px;
    border: 1px solid #A3A3A3;
}
  </style>
  